(() => {
  const closeLabel = document.currentScript.dataset.closeLabel;
  const visible = (el) => !!el && el.isConnected && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const focusable = (root) => [...root.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')].filter(el => el.tabIndex >= 0 && !el.disabled && !el.closest('[inert]') && visible(el));
  let size = null;
  let wishlist = null;
  let sizeTrigger = null;
  let wishlistTrigger = null;
  let queued = false;
  let serial = 0;
  const remember = (event) => {
    if (!(event.target instanceof Element)) return;
    const control = event.target.closest('a,button,[role="button"],[role="checkbox"]');
    if (!control) return;
    if (control.matches('.swym-header-launcher,.swym-add-to-wishlist') || control.closest('.swym-header-launcher')) wishlistTrigger = control.closest('.swym-header-launcher') || control;
    if (control.matches('.esc-size-guide--open') || control.getAttribute('href') === 'javascript:void(0)' && /size/i.test(control.textContent)) sizeTrigger = control;
  };
  document.addEventListener('click', remember, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') remember(event);
    if (!size || !visible(size.root)) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      size.close.click();
      schedule();
    } else if (event.key === 'Tab') {
      const items = focusable(size.root);
      const index = items.indexOf(document.activeElement);
      if (!items.length || event.shiftKey && index <= 0 || !event.shiftKey && (index < 0 || index === items.length - 1)) {
        event.preventDefault();
        (event.shiftKey ? items.at(-1) : items[0] || size.root).focus();
      }
    }
  }, true);
  document.addEventListener('focusin', event => {
    if (size && visible(size.root) && !size.root.contains(event.target)) size.close.focus();
  });
  const restore = (trigger) => requestAnimationFrame(() => {
    if (visible(trigger) && !trigger.closest('[inert]')) trigger.focus();
  });
  const isolate = (root) => {
    const previous = new Map();
    for (let branch = root; branch && branch !== document.body; branch = branch.parentElement) {
      for (const sibling of branch.parentElement.children) {
        if (sibling !== branch && !['SCRIPT','STYLE','LINK'].includes(sibling.tagName)) {
          previous.set(sibling, sibling.inert);
          sibling.inert = true;
        }
      }
    }
    return previous;
  };
  function sync() {
    queued = false;
    const root = [...document.querySelectorAll('.esc-size-guide--popup .modal_container')].find(visible);
    if (size && size.root !== root) {
      const previous = size;
      size = null;
      previous.background.forEach((value, el) => { el.inert = value; });
      restore(previous.trigger);
    }
    if (root && !size) {
      const title = root.querySelector('.esc-size-guide--title');
      const close = root.querySelector('.modal_close');
      if (title && close) {
        if (!title.id) title.id = 'mwm-size-title-' + ++serial;
        root.setAttribute('role', 'dialog');
        root.setAttribute('aria-modal', 'true');
        root.setAttribute('aria-labelledby', title.id);
        root.tabIndex = -1;
        close.setAttribute('role', 'button');
        close.setAttribute('aria-label', closeLabel);
        close.tabIndex = 0;
        if (!close.dataset.mwmKeyboard) {
          close.dataset.mwmKeyboard = 'true';
          close.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              close.click();
            }
          });
        }
        size = { root, close, trigger: sizeTrigger || document.activeElement, background: isolate(root.parentElement) };
        close.focus();
      }
    }
    const modal = [...document.querySelectorAll('.swym-modal-content')].find(visible);
    if (modal && !wishlist) wishlist = { trigger: wishlistTrigger || document.activeElement };
    if (!modal && wishlist) {
      const previous = wishlist;
      wishlist = null;
      requestAnimationFrame(() => {
        if (![...document.querySelectorAll('.swym-modal-content')].some(visible)) restore(previous.trigger);
      });
    }
  }
  function schedule() {
    if (!queued) {
      queued = true;
      requestAnimationFrame(sync);
    }
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  sync();
})();
